<template>
    <div class="coup">
        <div class="main">
            <div class="text">
            <p>
                Invite Friends <br>
                Get 3 Coupons each!
            </p>
            <p>
                Complete 10 rides and win a discount price for your next ride to any location.
                You can also win a free ride by referring your friend or family to use our service.
                  You will win a free ride when you refer up to 7 active users. 

            </p>
                <!-- <img src="../../assets/coup.png" alt="image"> -->
        </div>
        <div class="image">
            <img src="@/assets/Artwork.png" alt="image" class="coupimg">
        </div>
        </div>
    </div>
</template>
<script>
    import gsap from 'gsap'
    export default {
        name: 'Coupon',
        mounted() {
            gsap.to('.coupimg',
            // {
            //     y: 0,
            //     opacity: .8
            // },
            {
                y: -100,
                yoyo: true,
                ease: 'power1.inOut',
                repeat: -1,
                duration: 2
            }
            )
            // twn.reverse()
        }
    }
</script>
<style scoped>
    .coup{
        position: relative;
        width: 100%;
        margin: 0;
        padding: 1rem;
        /* margin-bottom: 3rem; */
        font-family: 'Helvetica', sans-serif;
        
    }
    .coup .main{
        position: relative;
        width: 100%;
        min-height: 300px;
        padding: 0;
        background-color: #f60;
        background-image: url('../../assets/Object.png');
        background-repeat: no-repeat;
        /* background-size: cover; */
        background-position-y: 0;
        border-radius: 10px;
    }
    .coup .text{
        position: relative;
        width: 0%;
        margin: 0;
        text-align: center;
        width: 100%;
        padding: 2rem;
        /* height: 700px; */
        border-radius: 10px;
        overflow: hidden;
        align-self: center;
    }
    .text p:nth-child(1){
        color: #fff;
        font-weight: 700px;
        font-size: 18px;
        margin-bottom: 1rem;
        line-height: 26px;
    }
    .text p:nth-child(2){
        color: #f5f5f5;
        font-weight: 400;
        line-height: 22px;
        font-size: 13px;
    }

    .coup .main .image {
        position: relative;
        max-width: 505px;
        height: 300px;
    }
    .coup .main .image img{
        position: absolute;
        top: 0;
        left: 0;
        max-width: 100%;
        height: 100%;
    }
 
    @media screen and (min-width:768px) {
        
        .coup .main{
            display: grid;
            grid-template-columns: 1fr 1fr;
        }
        .text p:nth-child(1){
            font-size: 20px;
            margin-bottom: 4rem;
        }
        .text p:nth-child(2){
            font-size: 15px;
            letter-spacing: 1px;
        }
        .coup .main .image {
            height: 400px;
        }
           
    }
    @media screen and (min-width:1010px) {
        .coup{
            padding: 1rem 4rem;
        }
        .coup .image{
            height: 500px;
        }
        .text p:nth-child(1){
            font-size: 30px;
            line-height: 36px;
            margin-bottom: 4rem;
        }
    }
    @media screen and (min-width: 1280px) {
        .coup{
            padding: 1rem 7rem;
        }
        .coup .image{
            height: 600px;
        }
    }
    </style>